export default __webpack_public_path__ + "static/media/earth.2bf17870.svg";